import { render, staticRenderFns } from "./Detour.vue?vue&type=template&id=64b2a2d6&scoped=true&lang=pug&"
import script from "./Detour.vue?vue&type=script&lang=js&"
export * from "./Detour.vue?vue&type=script&lang=js&"
import style0 from "./Detour.vue?vue&type=style&index=0&id=64b2a2d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b2a2d6",
  null
  
)

export default component.exports